import React from "react";
import { gql } from "@apollo/client";

import LegacyMouthpieceField from "components/mouthpiece/LegacyMouthpieceField";

export default function LegacyMouthpiece() {
  return <LegacyMouthpieceField name="legacyMouthpiece" />;
}

export function isAvailable() {
  return true;
}

export const tabName = "legacyMouthpiece";

export function TabLabel() {
  return (
    <span>
      Créer un bec
      <br />
      <small>(legacy)</small>
    </span>
  );
}

export async function handleSubmit(values, client) {
  return client
    .mutate({
      mutation: gql`
        mutation (
          $name: String!
          $instrument: String!
          $saxophoneType: String
          $clarinetType: String
          $params: LegacyMouthpieceParamsInput!
        ) {
          CreateLegacyMouthpiece(
            name: $name
            instrument: $instrument
            saxophoneType: $saxophoneType
            clarinetType: $clarinetType
            params: $params
          ) {
            legacyMouthpiece {
              id
            }
          }
        }
      `,
      variables: values.legacyMouthpiece,
    })
    .then(({ data }) => ({
      type: "legacyMouthpiece",
      legacyMouthpiece: data.CreateLegacyMouthpiece.legacyMouthpiece.id,
    }));
}
